import React, { useContext, useRef, useEffect } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import firebase from "../../firebase";
import FIREBASE from "firebase";
import { AuthContext } from "../../auth";
import { SnackbarAlert } from "../SnackbarAlert";

import Button from "@material-ui/core/Button";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputAdornment from "@material-ui/core/InputAdornment";

const CommentForm = (props) => {
  const { currentUser } = useContext(AuthContext);
  const { setSnackbarState } = useContext(SnackbarAlert);
  const elementRef = useRef(null);

  useEffect(() => {
    elementRef.current.focus();
  }, [props]);

  return (
    <Formik
      initialValues={{
        inputComment: "",
      }}
      validationSchema={Yup.object().shape({
        inputComment: Yup.string().required(),
      })}
      onSubmit={async (values, actions) => {
        ///*
        try {
          //do something
          let commentData = {};
          if (props.isComment) {
            commentData = {
              comment: values.inputComment,
              commentDate: FIREBASE.database.ServerValue.TIMESTAMP,
              commentEdited: false,
              commentName: currentUser.displayName,
              commentUserID: currentUser.uid,
              fromPost: props.id,
              votes: 0,
            };
          } else {
            commentData = {
              comment: values.inputComment,
              commentDate: FIREBASE.database.ServerValue.TIMESTAMP,
              commentEdited: false,
              commentName: currentUser.displayName,
              commentUserID: currentUser.uid,
              replyTo: props.name,
              fromPost: props.id,
              votes: 0,
            };
          }
          const newPostKey = await firebase
            .database()
            .ref()
            .child("comments/" + props.id)
            .push().key;
          let updates = {};
          updates["/comments/" + props.id + "/" + newPostKey] = commentData;
          await firebase.database().ref().update(updates);
          actions.resetForm();
          setSnackbarState({
            state: true,
            message: "Successfully posted! 👍",
            status: "info",
          });
        } catch (error) {
          //handle error
          actions.resetForm();
          //console.log(error);
          setSnackbarState({
            state: true,
            message: "Something went wrong. 😟",
            status: "error",
          });
        }
        //*/
      }}
    >
      {(formik) => (
        <form
          key={props.id}
          onSubmit={(e) => {
            e.preventDefault();
            formik.handleSubmit(e);
          }}
          noValidate
        >
          <OutlinedInput
            color={props.isComment ? "primary" : "secondary"}
            id="inputComment"
            name="inputComment"
            type="text"
            placeholder={
              props.isComment
                ? "Comment on this post."
                : `Reply on ${props.name}'s comment.`
            }
            startAdornment={
              <InputAdornment position="start">
                {props.isComment ? "" : props.name}
              </InputAdornment>
            }
            endAdornment={
              <InputAdornment position="end">
                <Button
                  color={props.isComment ? "primary" : "secondary"}
                  disabled={formik.isSubmitting}
                  type="submit"
                  disableElevation
                  fullWidth
                >
                  {props.isComment ? "Comment" : "Reply"}
                </Button>
              </InputAdornment>
            }
            {...formik.getFieldProps("inputComment")}
            inputRef={elementRef}
            multiline
            fullWidth
          />
        </form>
      )}
    </Formik>
  );
};

export default CommentForm;
